import { assertEqual } from "shelving";
import { Page } from "shared/react";
import { type ContentEntity, type ContentType, REACTOR_MAX } from "shared/schema";
import { EntityBackgroundHeader } from "../entity/EntityBackgroundHeader.js";
import { EntityButton } from "../entity/EntityButton.js";
import { RawRewardIcon } from "../reward/RewardIcon.js";
import { useItem } from "../util/db.js";
import { ReactorsTable } from "./ReactorsTable.js";

export function ReactorsPage({ filter, type, id }: { type: ContentType; id: string; filter: string }): React.ReactElement {
	const target: ContentEntity = `${type}:${id}`;
	const reward = useItem("reward", filter !== "all" ? filter : undefined);
	if (!reward) {
		return (
			<Page title="All reactions">
				<EntityBackgroundHeader entity={target} mods="pad-3x">
					<div>
						<h1>All reactions</h1>
					</div>
					<EntityButton entity={target} mods="pin-bottom pin-left size-small" />
				</EntityBackgroundHeader>
				<section>
					<ReactorsTable query={{ target, $limit: REACTOR_MAX }} />
				</section>
			</Page>
		);
	} else {
		const { id: rid, name, type: rewardType } = reward.data;
		assertEqual(rewardType, "reaction");
		return (
			<Page title={name}>
				<EntityBackgroundHeader entity={target} mods="pad-3x">
					<div className="flex-row flex-left">
						<RawRewardIcon {...reward.data} /> <span>{name}</span>
					</div>
					<EntityButton entity={target} mods="pin-bottom pin-left size-small" />
				</EntityBackgroundHeader>
				<section>
					<ReactorsTable query={{ target, reaction: rid, $limit: REACTOR_MAX }} />
				</section>
			</Page>
		);
	}
}
